import html2canvas from "html2canvas";
import jsPDF from "jspdf";

/**
 * Export a DOM element to PDF - captures the exact UI as rendered
 * @param {HTMLElement} element - DOM element to capture
 * @param {string} filename - Output filename
 * @param {object} options - { orientation: 'portrait'|'landscape', margin: number }
 */
export async function exportElementToPDF(element, filename, options = {}) {
  const { orientation = "portrait", margin = 10 } = options;

  // Temporarily expand element for full capture
  const originalOverflow = element.style.overflow;
  const originalMaxHeight = element.style.maxHeight;
  element.style.overflow = "visible";
  element.style.maxHeight = "none";

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    logging: false,
    backgroundColor: "#ffffff",
    windowWidth: element.scrollWidth,
    windowHeight: element.scrollHeight,
  });

  // Restore element
  element.style.overflow = originalOverflow;
  element.style.maxHeight = originalMaxHeight;

  const imgData = canvas.toDataURL("image/jpeg", 0.95);
  const pdf = new jsPDF(orientation, "mm", "a4");

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const usableWidth = pageWidth - margin * 2;
  const usableHeight = pageHeight - margin * 2;

  const imgWidth = usableWidth;
  const imgHeight = (canvas.height * usableWidth) / canvas.width;

  // Multi-page support
  let yOffset = 0;
  let page = 0;

  while (yOffset < imgHeight) {
    if (page > 0) pdf.addPage();

    // Calculate source region for this page
    const sourceY = (yOffset / imgHeight) * canvas.height;
    const sourceHeight = Math.min(
      (usableHeight / imgHeight) * canvas.height,
      canvas.height - sourceY
    );
    const destHeight = Math.min(usableHeight, imgHeight - yOffset);

    // Create a temporary canvas for this page slice
    const pageCanvas = document.createElement("canvas");
    pageCanvas.width = canvas.width;
    pageCanvas.height = sourceHeight;
    const ctx = pageCanvas.getContext("2d");
    ctx.drawImage(
      canvas,
      0, sourceY, canvas.width, sourceHeight,
      0, 0, canvas.width, sourceHeight
    );

    const pageImgData = pageCanvas.toDataURL("image/jpeg", 0.95);
    pdf.addImage(pageImgData, "JPEG", margin, margin, imgWidth, destHeight);

    yOffset += usableHeight;
    page++;
  }

  pdf.save(filename);
}
